// extracted by mini-css-extract-plugin
module.exports = {"iconsList":"SocialMediaShareLinks_iconsList__20qz8","iconCard":"SocialMediaShareLinks_iconCard__Ie_pW","share":"SocialMediaShareLinks_share__1-Uk3"};